// extracted by mini-css-extract-plugin
module.exports = {"label":"VolumeInfo_label-3lNOw","row":"VolumeInfo_row-34POO","expendVolumeIcon":"VolumeInfo_expendVolumeIcon-2_mrz","labelTooltip":"VolumeInfo_labelTooltip-2zTXH"};